import { cn } from '@/utils';
import { FaPencilAlt } from 'react-icons/fa';
import { useChatImage } from '@/hooks/useChatImage';
import { useImageState } from '@/contexts/ImageContext';

interface ChatImageProps {
  readonly src: string;
  readonly alt: string;
  readonly index: number;
  readonly messageId : string;
  readonly className?: string;
}

export function ChatImage({ src, alt, index,messageId, className = "" }: ChatImageProps) {
  const { handleImageClick, handleMouseOver, handleMouseOut } = useChatImage({ index,messageId });
  const { selectedImageIndex, isSelected, selectedImage ,selectedImageMessageId, hoverImageMessageId } = useImageState();


  // Show icons if:
  // 1. Edit mode is enabled (imageIcon = true) AND
  // 2. Either the image is being hovered OR the image is currently selected for viewing

  let isIconVisible = false;
  const isCurrentSelected = isSelected === index && selectedImageMessageId === messageId;

  // making icons visible only on hover basis
  //selected image is getting change on clicking the image
  //selectedImageIndex is getting chnaged on the hover

  const isSelectedImage = messageId === selectedImageMessageId && selectedImage === index;
  const isHoveredImage = messageId === hoverImageMessageId && index === selectedImageIndex;

  if (isSelectedImage || isHoveredImage) {
    isIconVisible = true;
  }



  return (
    <button 
      className="relative group bg-transparent border-none p-0 cursor-pointer"
      draggable
      onDragStart={(e) => {
        e.dataTransfer.effectAllowed = 'copy';
        e.dataTransfer.setData('text/uri-list', src);
        e.dataTransfer.setData('text/plain', src);
        e.dataTransfer.setData('application/x-dpc-image-url', src);
      }}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onFocus={handleMouseOver}
      onBlur={handleMouseOut}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleImageClick();
        }
      }}
      onClick={handleImageClick}
      aria-label={`Image ${index + 1}: ${alt}`}
    >
      <img
        src={src}
        alt={alt}
        className={cn(
          "rounded-lg border border-gray-200 dark:border-gray-600",
          className // Apply size classes and other styles from parent
        )}
        onError={(e) => {
          console.error(`Failed to load image ${index + 1}:`, e);
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
      {isIconVisible && (
        <div className="absolute top-1 right-2 flex flex-col space-y-4">
          <div 
            className={cn(
              isCurrentSelected ? 'bg-blue-400' : 'bg-slate-800',
              'p-2 rounded-full shadow-md pointer-events-none'
            )}
          >
            <FaPencilAlt className="text-white" />
          </div>
        </div>
      )}
    </button>
  );
}
